<section class="table-page table-page--compact mis-proyectos-page mis-proyectos-detail-page hucu-epicas-page">
  <div class="table-page__hero">
    <div class="table-page__copy">
      <h1>Actividades del Proyecto</h1>
      <p>Consulte épicas, casos de uso, historias de usuario y tareas relacionadas con el proyecto.</p>
    </div>

    <div class="table-page__toolbar-actions">
      <button mat-raised-button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary"
        (click)="regresarLista()">
        <span class="material-icons">arrow_back</span>
        <span>Regresar</span>
      </button>
    </div>
  </div>

  <section class="table-page__card">
    <div class="table-page__toolbar table-page__toolbar--filters">
      <div class="table-page__filters-grid">
        <mat-form-field appearance="outline" class="table-page__field table-page__filter table-page__filter--wide">
          <mat-label>Nuevo elemento</mat-label>
          <mat-select [(ngModel)]="tipoSeleccionado" (selectionChange)="seleccionarTipo($event)">
            <mat-option value="EPICA">Épicas</mat-option>
            <mat-option value="CU">Casos de uso</mat-option>
            <mat-option value="HU">Historias de usuario</mat-option>
            <mat-option value="TAREA">Tareas</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field table-page__filter table-page__filter--medium">
          <mat-label>Filtrar por tipo</mat-label>
          <mat-select [(ngModel)]="filtroSeleccionado" (selectionChange)="filtroChanged($event)">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option value="EPICA">Épicas</mat-option>
            <mat-option value="CU">Casos de uso</mat-option>
            <mat-option value="HU">Historias de usuario</mat-option>
          </mat-select>
          <button *ngIf="filtroSeleccionado" type="button" mat-icon-button matSuffix (click)="clear()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field *ngIf="showSecondaryFilter" appearance="outline"
          class="table-page__field table-page__filter table-page__filter--wide">
          <mat-label>{{ secondaryFilterLabel }}</mat-label>
          <mat-select [(ngModel)]="filtlroSeleccionadoTareas"
            (selectionChange)="filtroTareaCu($event, filtroSeleccionado || '')">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option *ngFor="let option of secondaryFilterOptions" [value]="option.id">
              {{ option.nombre }}
            </mat-option>
          </mat-select>
          <button *ngIf="filtlroSeleccionadoTareas" type="button" mat-icon-button matSuffix
            (click)="limpiaFiltroTareas()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="table-page__toolbar-actions">
        <button *ngIf="filtroSeleccionado || filtlroSeleccionadoTareas" mat-raised-button type="button"
          class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="limpiaTodo()">
          <span class="material-icons">filter_alt_off</span>
          <span>Limpiar filtros</span>
        </button>
      </div>
    </div>

    <div class="table-page__table-wrap">
      <table class="table-page__table table-page__table--wide" *ngIf="listEpicas.length > 0; else epicasEmptyState">
        <thead>
          <tr>
            <th>Elemento</th>
            <th>Descripción</th>
            <th>Responsable</th>
            <th>Fecha</th>
            <th>Prioridad</th>
            <th>Estatus</th>
            <th class="table-page__actions-head">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of listEpicas" class="is-clickable"
            (dblclick)="hasTaskFilter ? modificarTarea(row) : modificar(row)">
            <td>
              <div class="table-page__cell-stack">
                <strong class="table-page__name">{{ row.nombre || "Sin nombre" }}</strong>
                <span class="table-page__subtext">ID {{ row.id }} · {{ getTypeLabel(row) }}</span>
              </div>
            </td>
            <td>
              <span class="table-page__description">{{ row.descripcion || "Sin descripción" }}</span>
            </td>
            <td>
              <span class="table-page__text">{{ getResponsableLabel(row) }}</span>
            </td>
            <td>
              <span class="table-page__text">{{ getDateValue(row) | date: "dd/MM/yyyy" }}</span>
            </td>
            <td>
              <span class="table-page__text">{{ getPriorityLabel(row) }}</span>
            </td>
            <td>
              <span class="table-page__status-badge" [ngClass]="getStatusClass(row)">
                {{ getStatusLabel(row) }}
              </span>
            </td>
            <td class="table-page__actions">
              <button type="button" class="table-page__action-btn" matTooltip="Editar"
                (click)="hasTaskFilter ? modificarTarea(row) : modificar(row)">
                <i class="material-icons">edit</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #epicasEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else epicasLoadingState">
          <i class="material-icons">view_list</i>
          <strong>No hay actividades para mostrar</strong>
          <span>Pruebe con otro filtro o agregue un nuevo elemento al proyecto.</span>
        </div>
      </ng-template>

      <ng-template #epicasLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando actividades...</strong>
        </div>
      </ng-template>
    </div>

    <div class="table-page__footer" *ngIf="showPagination">
      <div class="table-page__meta">
        <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} registros</span>
        <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

        <label class="table-page__page-size">
          <span>Ver:</span>
          <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
      </div>

      <div class="table-page__pager" *ngIf="totalPages > 0">
        <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
          Inicio
        </button>
        <button type="button" class="table-page__pager-link" (click)="previousPage()"
          [disabled]="currentPage === 1">
          Anterior
        </button>

        <ng-container *ngFor="let item of getPaginationItems()">
          <button *ngIf="isPageNumber(item); else epicasPagerEllipsis" type="button" class="table-page__pager-page"
            [class.is-current]="item === currentPage" (click)="onPageChange(item)">
            {{ item }}
          </button>

          <ng-template #epicasPagerEllipsis>
            <span class="table-page__pager-ellipsis">...</span>
          </ng-template>
        </ng-container>

        <button type="button" class="table-page__pager-link" (click)="nextPage()"
          [disabled]="currentPage === totalPages">
          Siguiente
        </button>
        <button type="button" class="table-page__pager-link" (click)="lastPage()"
          [disabled]="currentPage === totalPages">
          Último
        </button>
      </div>
    </div>
  </section>
</section>
